import { Component, inject, OnInit } from '@angular/core';
import { AppkitService } from '../../../modules/services/appkit.service';
import { Router } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  appkitService = inject(AppkitService);
  router = inject(Router);
  toastr = inject(ToastrService);
  connectedWalletAddress: any;

  ngOnInit(): void {
    initFlowbite();
    const loginResponse = JSON.parse(localStorage.getItem('loginResponse') || '');
    this.connectedWalletAddress = loginResponse.walletAddress
  }

  /**
   * Signs out
   */
  async signOut() {
    try {
      await this.appkitService.disconnectWallet();
    } catch (err) {
      console.warn('Non-critical wallet disconnect error:', err);
    } finally {
      localStorage.clear();
      this.router.navigate(['/']);
      this.toastr.success('Logout successful');
    }
  }  
}
